import Vue from "vue";
import VueRouter from "vue-router";

// top
import Home from "@/components/page/home/App.vue";

// 各固定ページ
import Concept from "@/components/page/fixed_page/App.vue";
import Service from "@/components/page/fixed_page/App.vue";
import Catalog from "@/components/page/fixed_page/App.vue";
import Information from "@/components/page/fixed_page/App.vue";
import Voice from "@/components/page/fixed_page/App.vue";
import Calendar from "@/components/page/fixed_page/App.vue";
import Access from "@/components/page/fixed_page/App.vue";
import Faq from "@/components/page/fixed_page/App.vue";
import Download from "@/components/page/fixed_page/App.vue";
import Recruit from "@/components/page/fixed_page/App.vue";
import Privacypolicy from "@/components/page/fixed_page/App.vue";

// coupon
import Coupon from "@/components/page/coupon/App.vue";

// news
import NewsList from "@/components/page/news/list/App.vue";
import NewsDetail from "@/components/page/news/detail/App.vue";

// research
import Research from "@/components/page/research/App.vue";

// contact
import Contact from "@/components/page/contact/App.vue";

// 404エラー
import NotFound from "@/components/system/Page404.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Home,
        meta: {
            title: "Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/concept",
        component: Concept,
        meta: {
            title: "CONCEPT - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/service",
        component: Service,
        meta: {
            title: "SERVICE - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/catalog",
        component: Catalog,
        meta: {
            title: "MENU - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/information",
        component: Information,
        meta: {
            title: "SCENE - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/voice",
        component: Voice,
        meta: {
            title: "STAFF - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/calendar",
        component: Calendar,
        meta: {
            title: "CALENDAR - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/access",
        component: Access,
        meta: {
            title: "ABOUT - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/faq",
        component: Faq,
        meta: {
            title: "FAQ - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/download",
        component: Download,
        meta: {
            title: "download - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/recruit",
        component: Recruit,
        meta: {
            title: "recruit - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/privacypolicy",
        component: Privacypolicy,
        meta: {
            title: "PRIVACYPOLICY - Tooooo Lemon(トゥーレモン)",
        },
    },

    {
        path: "/coupon",
        component: Coupon,
        meta: {
            title: "coupon - Tooooo Lemon(トゥーレモン)",
        },
    },

    {
        path: "/news",
        component: NewsList,
        meta: {
            title: "NEWS - Tooooo Lemon(トゥーレモン)",
        },
    },
    {
        path: "/news/:id",
        component: NewsDetail,
        meta: {
            title: "NEWS - Tooooo Lemon(トゥーレモン)",
        },
    },

    {
        path: "/research",
        component: Research,
        meta: {
            title: "research - Tooooo Lemon(トゥーレモン)",
        },
    },

    {
        path: "/contact",
        component: Contact,
        meta: {
            title: "CONTACT - Tooooo Lemon(トゥーレモン)",
        },
    },

    {
        path: "*",
        name: "NotFound",
        component: NotFound,
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },

    data() {
        return {
            meta: [],
        };
    },

    created() {
        this.axios.get("/json/settings.json").then((response) => {
            this.meta = response.data.settings.general;
        });
    },
});

export default router;
